module.exports = __webpack_public_path__ + "images/obogrev-trub.aee7917f.jpg";